import { useAtomValue, useSetAtom } from "jotai";
import { useCallback, useEffect } from "react";

import {
  jobEditorAtom,
  loadJobEditorAtom,
  saveJobAtom,
} from "../stores/editor";

export type UseJobEditorOptions = {
  projectId: number;
  jobId?: number | null;
  onSaved?: (jobId: number) => void;
  onCancel?: () => void;
};

export type UseJobEditor = {
  loading: boolean;
  saving: boolean;
  error: string | null;
  conflict: boolean;
  save: () => Promise<void>;
  cancel: () => void;
};

export function useJobEditor({
  projectId,
  jobId = null,
  onSaved,
  onCancel,
}: UseJobEditorOptions): UseJobEditor {
  const { loading, saving, error, conflict } = useAtomValue(jobEditorAtom);

  const load = useSetAtom(loadJobEditorAtom);
  const saveJob = useSetAtom(saveJobAtom);

  useEffect(() => {
    void load(projectId, jobId);
  }, [load, projectId, jobId]);

  const save = useCallback(async () => {
    const savedId = await saveJob();

    if (null !== savedId) {
      onSaved?.(savedId);
    }
  }, [saveJob, onSaved]);

  const cancel = useCallback(() => onCancel?.(), [onCancel]);

  return { loading, saving, error, conflict, save, cancel };
}
